import { render, staticRenderFns } from "./PreordersList.vue?vue&type=template&id=dc53f536&"
import script from "./PreordersList.vue?vue&type=script&lang=js&"
export * from "./PreordersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports